import { TextAreaEditor } from '@approvalmax/ui';
import styled from 'styled-components';

export const TermsSection = styled(TextAreaEditor)`
    width: 50%;
    min-height: 90px;
`;
